import network from '@/services/network';
import {
  ApiResponse,
  BookingSource,
  CreateBookingSourceRequest,
  UpdateBookingSourceRequest,
} from '@/types';
import { ErrorResponse } from '@/utils';

/**
 * Buchungsquellen haengen unter ihrem Pool (Entscheid Alex 05.08.2026). Es
 * gibt keine systemweite Liste mehr — jede Anfrage nennt den Pool.
 */
const basis = (poolId: number) => `/meeting-pools/${poolId}/booking-sources`;

const getBookingSources = async (poolId: number): Promise<ApiResponse<BookingSource[]>> => {
  try {
    const { data } = await network.get<ApiResponse<BookingSource[]>>(basis(poolId));
    return data;
  } catch (error) {
    throw new ErrorResponse(error);
  }
};

const createBookingSource = async (
  poolId: number,
  payload: CreateBookingSourceRequest,
): Promise<ApiResponse<BookingSource>> => {
  try {
    const { data } = await network.post<ApiResponse<BookingSource>>(basis(poolId), payload);
    return data;
  } catch (error) {
    throw new ErrorResponse(error);
  }
};

const updateBookingSource = async (
  poolId: number,
  id: number,
  payload: UpdateBookingSourceRequest,
): Promise<ApiResponse<BookingSource>> => {
  try {
    const { data } = await network.put<ApiResponse<BookingSource>>(
      `${basis(poolId)}/${id}`,
      payload,
    );
    return data;
  } catch (error) {
    throw new ErrorResponse(error);
  }
};

// Bewusst KEIN delete: Buchungsquellen werden abgeschaltet, nicht geloescht
// (sonst verlieren Alt-Termine ihre Herkunft). Das Backend hat dafuer auch
// keine Route.
const bookingSourceApi = {
  getBookingSources,
  createBookingSource,
  updateBookingSource,
};

export default bookingSourceApi;
